import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  SvgIcon,
  DialogTitle,
  DialogContentText,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { copyAllIcon } from '../../../../public/images/svgPath.json';

const useStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
}));

interface IProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onModalClose: Function;
  showModal: boolean;
  summaryType?: 'ext' | 'abs';
  extSentences?: { text: string }[];
  absSummary?: string;
  classes?: Record<string, string>;
}

function CopyAllBtn(props: IProps) {
  const classes = useStyles(props);
  /* const [dialogOpen, setDialogOpen] = useState(false)
  const closeDialog = () => {
    setDialogOpen(false)
  } */
  const getOutputHtml = () => {
    const outputElem = document.getElementById('outputBoxSummarizer');
    let innerHtml = '';
    if (outputElem) {
      innerHtml = outputElem.innerHTML;
    }
    return innerHtml;
  };
  return (
    <div>
      <Tooltip
        arrow
        title={
          QuillLocalStorage.getInstance().get('showToolTips', 'true') === 'true'
            ? 'Copy Full Text'
            : ''
        }
      >
        <IconButton onClick={props.onClick} classes={classes} size="large">
          <SvgIcon>
            <path fill="inherit" {...copyAllIcon} />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <Dialog maxWidth="md" open={props.showModal} aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title">Manually Copy Text To Your Clipboard</DialogTitle>
        <DialogContent>
          {/* @TODO: Check if it works */}
          <DialogContentText>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: getOutputHtml(),
              }}
            />
            {props.summaryType === 'ext' ? (
              props.extSentences?.map((sentenceObj: { text: string }) => (
                <li key={sentenceObj.text}>{sentenceObj.text}</li>
              ))
            ) : (
              <div>{props.absSummary}</div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.onModalClose()} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CopyAllBtn;
